import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import Institucional from '../../../components/auth/institucional'

function InstitucionalScreen() {
        return (
            <Fragment>
                <Head titulo="Transparência - Institucional" />
                <HeaderLogged />
                <Container>
                   <Institucional />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default InstitucionalScreen;